import { Reveal } from "./Reveal";
import { EVENTS_WE_SERVE } from "../lib/data";

export const EventsWeServe = () => (
  <section id="events" data-testid="events-section" className="relative py-20 md:py-32 border-t border-white/5 bg-[#080808] scroll-mt-24">
    <div className="mx-auto max-w-[1400px] px-5 md:px-10">
      <div className="max-w-3xl mb-12 md:mb-16">
        <Reveal>
          <p className="text-xs uppercase tracking-[0.3em] text-[#D4AF37] mb-5 md:mb-6">Events We Serve</p>
        </Reveal>
        <Reveal delay={0.1}>
          <h2 className="font-display font-black uppercase tracking-tight text-white text-3xl sm:text-4xl md:text-6xl leading-[0.95]">
            Built for every <span className="text-[#D4AF37]">premium moment.</span>
          </h2>
        </Reveal>
      </div>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 gap-4 md:gap-5">
        {EVENTS_WE_SERVE.map((e, i) => {
          const Icon = e.icon;
          return (
            <Reveal key={e.label} delay={0.04 * (i % 5)}>
              <div
                data-testid={`event-item-${i}`}
                className="h-full bg-[#0a0a0a] border border-white/5 hover:border-[#D4AF37]/40 transition-colors duration-500 p-5 md:p-6 flex flex-col items-start gap-4 group min-h-[130px] md:min-h-[150px]"
              >
                <Icon className="w-6 h-6 md:w-7 md:h-7 text-[#D4AF37] group-hover:scale-110 transition-transform duration-300" strokeWidth={1.4} />
                <span className="mt-auto font-display uppercase tracking-wide text-white text-sm md:text-base leading-tight">{e.label}</span>
              </div>
            </Reveal>
          );
        })}
      </div>
    </div>
  </section>
);
